export function fromRI(re, im) {
    return { re, im };
}
export function fromMA(mag, angDeg) {
    const rad = (angDeg * Math.PI) / 180;
    return { re: mag * Math.cos(rad), im: mag * Math.sin(rad) };
}
export function fromDB(dbMag, angDeg) {
    const mag = 10 ** (dbMag / 20);
    return fromMA(mag, angDeg);
}
export function toMA(c) {
    const mag = Math.hypot(c.re, c.im);
    const angDeg = mag === 0 ? 0 : (Math.atan2(c.im, c.re) * 180) / Math.PI;
    return { mag, angDeg };
}
//# sourceMappingURL=format-convert.js.map